import Immutable from 'seamless-immutable';

import * as companyActionTypes from './action-types';

const defaultPerPage = Number(process.env.REACT_APP_ADMIN_DEFAULT_PAGE_SIZE) || 50;

const listingInitialState = Immutable({
  companies: [],
  fetching: false,
  currentPage: null,
  perPage: defaultPerPage,
  totalCompanies: 0,
  sort: { field: '', order: null },
  matchingCompanies: 0,
});

export default function companiesVerificationDetails(state = listingInitialState, action) {
  switch (action.type) {
    case companyActionTypes.FETCH_COMPANIES_VERIFICATION_DETAILS.REQUEST:
      const { pageNo: fetchingPage, perPage: fetchingPerPage, sort: fetchingSort } = action.payload;
      return state.merge({
        companies: [],
        fetching: true,
        currentPage: fetchingPage,
        perPage: fetchingPerPage || defaultPerPage,
        totalCompanies: 0,
        sort: fetchingSort,
        matchingCompanies: 0,
      });
    case companyActionTypes.FETCH_COMPANIES_VERIFICATION_DETAILS.SUCCESS:
      const { pageNo: currentPage } = action.payload.input;
      const { companies, totalCompanies, matchingCompanies } = action.payload.result;

      return state.merge({
        companies,
        fetching: false,
        currentPage,
        totalCompanies,
        matchingCompanies:
          typeof matchingCompanies === 'number' ? matchingCompanies : totalCompanies,
        error: null,
      });
    case companyActionTypes.FETCH_COMPANIES_VERIFICATION_DETAILS.FAILURE:
      return state.merge({
        companies: [],
        fetching: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/features/companies-verification-listings/reducer.js